import { ergoBoxFromProxy, ergoBoxToProxy } from "./ergoBox";
export function ergoTxFromProxy(proxy) {
    return {
        ...proxy,
        outputs: proxy.outputs.map(o => ergoBoxFromProxy(o))
    };
}
export function ergoTxToProxy(tx) {
    return {
        ...tx,
        outputs: tx.outputs.map(o => ergoBoxToProxy(o))
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJnb1R4LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2VyZ28vZW50aXRpZXMvZXJnb1R4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBVSxnQkFBZ0IsRUFBZ0IsY0FBYyxFQUFDLE1BQU0sV0FBVyxDQUFBO0FBb0JqRixNQUFNLFVBQVUsZUFBZSxDQUFDLEtBQWtCO0lBQ2hELE9BQU87UUFDTCxHQUFHLEtBQUs7UUFDUixPQUFPLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxnQkFBZ0IsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUNyRCxDQUFBO0FBQ0gsQ0FBQztBQUVELE1BQU0sVUFBVSxhQUFhLENBQUMsRUFBVTtJQUN0QyxPQUFPO1FBQ0wsR0FBRyxFQUFFO1FBQ0wsT0FBTyxFQUFFLEVBQUUsQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQ2hELENBQUE7QUFDSCxDQUFDIn0=